/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DeleteAiScanTargetRequestBody,
  DeleteAiScanTargetRequestBody$Outbound,
  DeleteAiScanTargetRequestBody$outboundSchema,
} from "../components/deleteaiscantargetrequestbody.js";

export type DeleteAiScanTargetSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteAiScanTargetRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  deleteAiScanTargetRequestBody: DeleteAiScanTargetRequestBody;
};

/** @internal */
export type DeleteAiScanTargetSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteAiScanTargetSecurity$outboundSchema: z.ZodMiniType<
  DeleteAiScanTargetSecurity$Outbound,
  DeleteAiScanTargetSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteAiScanTargetSecurityToJSON(
  deleteAiScanTargetSecurity: DeleteAiScanTargetSecurity,
): string {
  return JSON.stringify(
    DeleteAiScanTargetSecurity$outboundSchema.parse(deleteAiScanTargetSecurity),
  );
}

/** @internal */
export type DeleteAiScanTargetRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  DeleteAiScanTargetRequestBody: DeleteAiScanTargetRequestBody$Outbound;
};

/** @internal */
export const DeleteAiScanTargetRequest$outboundSchema: z.ZodMiniType<
  DeleteAiScanTargetRequest$Outbound,
  DeleteAiScanTargetRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    deleteAiScanTargetRequestBody: DeleteAiScanTargetRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      deleteAiScanTargetRequestBody: "DeleteAiScanTargetRequestBody",
    });
  }),
);

export function deleteAiScanTargetRequestToJSON(
  deleteAiScanTargetRequest: DeleteAiScanTargetRequest,
): string {
  return JSON.stringify(
    DeleteAiScanTargetRequest$outboundSchema.parse(deleteAiScanTargetRequest),
  );
}
